import ICONS from "../../../../../assets/Icons";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import SVGComponent from "../../../../_utils/SVGComponent";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import Loader from "../../../../Loader/Index";
import RemitAccountViewAllPopup from "../../RemitAccountViewAllPopup";

const RemitAccountStepName = ({
  accountPayLoad,
  setAccountPayLoad,
  setLabelpopup,
  isDuplicate,
  setIsDuplicate,
  openSimilarPopup,
  setOpenSimilarPopup,
  duplicateLoading,
  setDuplicateLoading,
  checkDuplicateAccount,
}) => {
  return (
    <>
      {openSimilarPopup && (
        <RemitAccountViewAllPopup
          remName={accountPayLoad?.remitterAccountName.trim()}
          type={"RemitterAcc"}
          headerTitle={"Similar accounts"}
          headersubtext={
            "The following accounts have similar names and require a unique name before creating a remitter account."
          }
          closePopup={setOpenSimilarPopup}
          onCardNavigate
        />
      )}

      {duplicateLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className="w-width-full max-w-tab-width-normal flex flex-col gap-y-gap-md">
          <div className="flex flex-col Qlg:flex-row lg:gap-gap-xl gap-gap-md Qmd:justify-between pt-padding-md Qmd:pt-padding-base px-padding-md Qmd:px-padding-base">
            <div className="flex flex-col gap-gap-md w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
              {isDuplicate && (
                <div className="flex items-start gap-gap-sm bg-emphasis rounded-border-radius-md p-padding-md">
                  <img
                    src={ICONS?.ERROR_WHITE_CIRCLE}
                    alt="error"
                    className="w-icon-md h-icon-md flex-shrink-0"
                  />
                  <p className="text-font-xs text-text-primary">
                    Change the account name to proceed with creation.
                  </p>
                </div>
              )}
              <NameFieldCard
                title="Account Name"
                placeholder="Account name"
                fieldName="remitter_name"
                value={accountPayLoad?.remitterAccountName}
                mode="soft"
                hasError={isDuplicate}
                onChange={(val) => {
                  const cleaned = val.trimStart();
                  setAccountPayLoad({
                    ...accountPayLoad,
                    remitterAccountName: cleaned,
                  });
                  setIsDuplicate(false);
                }}
              />

              {isDuplicate && (
                <div
                  className="flex gap-gap-md justify-between items-center w-full rounded-border-radius-md bg-primary-card p-padding-md cursor-pointer global-hover-white z-z-index-content relative"
                  onClick={() => {
                    setOpenSimilarPopup(true);
                  }}
                >
                  <div className="flex flex-col gap-gap-sm w-width-full">
                    <div className="w-full h-auto font-semibold text-base text-text-primary flex justify-between items-center">
                      <h1>Similar Accounts Found</h1>

                      <SVGComponent
                        url={ICONS.ARROW_RIGHT_WHITE}
                        height={"var(--icon-md)"}
                        width={"var(--icon-md)"}
                        color={"var(--text-primary)"}
                      />
                    </div>
                    <ul className="w-full h-auto font-normal text-xs text-text-secondary list-disc pl-padding-md flex flex-col gap-gap-sm">
                      <li>Click here to view and manage the account.</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
              <AssignLabels
                setLabelpopup={setLabelpopup}
                labels={accountPayLoad?.labels}
                subText1="Labels will be used to generate statistics for the associated accounts."
                isOptional={true}
              />
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default RemitAccountStepName;
